import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import rafSchedule from 'raf-schd';

// Need to make outer div full height in case consumer wants to align
// child content vertically center. These styles can be overridden by the
// product using the optional SizeDetector.containerStyle prop.
var containerDivStyle = {
  height: '100%',
  flex: '1 0 auto',
  position: 'relative'
};

// Not using styled-components here for performance
// and framework-agnostic reasons.
var objectStyle = {
  display: 'block',
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  opacity: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: -1
};

var SizeDetector = function (_Component) {
  _inherits(SizeDetector, _Component);

  function SizeDetector(props) {
    _classCallCheck(this, SizeDetector);

    var _this = _possibleConstructorReturn(this, (SizeDetector.__proto__ || _Object$getPrototypeOf(SizeDetector)).call(this, props));

    _this.handleResize = rafSchedule(function () {
      var container = _this.container;

      if (!container) {
        return;
      }

      var sizeMetrics = {
        width: container.offsetWidth,
        height: container.offsetHeight
      };

      _this.setState({
        sizeMetrics: sizeMetrics
      });

      if (_this.props.onResize) {
        _this.props.onResize(sizeMetrics);
      }
    });

    _this.handleContainerRef = function (ref) {
      if (!ref) {
        return;
      }
      _this.container = ref;
      _this.handleResize();
    };

    _this.handleObjectRef = function (ref) {
      if (!ref) {
        return;
      }
      _this.resizeObject = ref;
    };

    _this.handleObjectLoad = function () {
      if (!_this.resizeObject) {
        return;
      }

      // $FlowFixMe - resizeObject is typed as HTMLElement which has no contentDocument prop
      _this.resizeObjectDocument = _this.resizeObject.contentDocument.defaultView;
      _this.resizeObjectDocument.addEventListener('resize', _this.handleResize);
    };

    _this.renderChildren = function () {
      var sizeMetrics = _this.state.sizeMetrics;

      if (!sizeMetrics) {
        return null;
      }
      return _this.props.children(sizeMetrics);
    };

    _this.state = {};
    return _this;
  }

  _createClass(SizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.resizeObject) {
        // $FlowFixMe - resizeObject is HTMLElement which doesn't contain .data prop
        this.resizeObject.data = 'about:blank';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();

      if (this.resizeObjectDocument) {
        this.resizeObjectDocument.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        {
          style: _extends({}, containerDivStyle, this.props.containerStyle),
          ref: this.handleContainerRef
        },
        React.createElement('object', {
          type: 'text/html',
          style: objectStyle,
          ref: this.handleObjectRef,
          onLoad: this.handleObjectLoad,
          'aria-hidden': true,
          tabIndex: -1
        }),
        this.renderChildren()
      );
    }
  }]);

  return SizeDetector;
}(Component);

SizeDetector.defaultProps = {
  // eslint-disable-line react/sort-comp
  containerStyle: {}
};
export default SizeDetector;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/size-detector/dist/esm/SizeDetector.js
// module id = 706
// module chunks = 0